export default __webpack_public_path__ + "static/media/testing-green.55f36c55.svg";